import { cn } from '@/lib/utils';

/** Logótipo oficial Aluthea — sem filtros que o branqueiem. */
export function BrandLogo({ className, imgClassName, onDark = false, alt = 'Aluthea Group' }) {
  const img = (
    <img
      src="/aluthea-logo.png"
      alt={alt}
      className={cn('h-7 w-auto object-contain', imgClassName)}
    />
  );
  if (!onDark) return img;
  return (
    <div
      className={cn(
        'inline-flex items-center rounded-md bg-white px-2 py-1 shadow-sm',
        className,
      )}
    >
      {img}
    </div>
  );
}
